import { AxiosResponse } from 'axios'

const headerKeyTotalCount = 'x-total-count'

function getTotalCount(response: AxiosResponse): number | undefined {
  return Number(response.headers[headerKeyTotalCount])
}

export default getTotalCount
